import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=56f7b41a&scoped=true&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=56f7b41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7b41a",
  null
  
)

export default component.exports